import React from 'react';

const SearchItem = ({ imageSrc, title, url, description, onClick }) => {
    return (
        <div className='PortfolioSearchItem SearchItem' onClick={onClick} style={{ cursor: 'pointer' }}>
            <img src={imageSrc} alt='Preview' />
            <div className='SearchItemInfo'>
                <h1 className='Title'>{title}</h1>
                {/* <a className='URL' href={url} target='_blank' rel='noopener noreferrer'>{url}</a> */}
                <a className='URL'>{url}</a>
                <span className='Description'>{description}</span>
            </div>
        </div>
    );
};

export default SearchItem;
